export default ({ data }) => {
  return {
    text: data.text,
  };
};
